import { AfterViewInit, Directive, ElementRef, Input, OnDestroy, Renderer2 } from '@angular/core';

import { EnvUtils } from '@ecm/dispatcher';

// This directive allow to disable link, button, input element
// Be carefull, its inclusion is possibly conditioned by environment or other
@Directive({
    selector: '[ecmDisabledAction]:not([ecmDisabledAction=false])',
    standalone: true,
})
export class MaterialDisabledActionDirective implements AfterViewInit, OnDestroy {
    @Input() public ecmDisabledAction: boolean | string;

    /**
     * unlisten function for link element
     * @type Function
     */
    private unlisten: () => void;

    /**
     * Constructor
     * @param {ElementRef} DOM element
     * @param {Renderer2} renderer element
     */
    public constructor(
        private element: ElementRef,
        private renderer: Renderer2,
    ) {}

    /**
     * Directive initialization
     */
    public ngAfterViewInit(): void {
        if (EnvUtils.isEclair() && (this.ecmDisabledAction || this.ecmDisabledAction === '')) {
            const DOMElement: any = this.element.nativeElement;

            this.renderer.addClass(DOMElement, 'ecm-disabled-action');
            this.renderer.setAttribute(DOMElement, 'aria-disabled', 'true');

            switch (DOMElement.tagName) {
                case 'A': {
                    this.renderer.setAttribute(DOMElement, 'href', '');

                    // clone element allow to reset all event listeners, routerLink included, on it
                    const cloneDOMElement: any = DOMElement.cloneNode(true);
                    DOMElement.parentNode.replaceChild(cloneDOMElement, DOMElement);
                    this.unlisten = this.renderer.listen(cloneDOMElement, 'click', () => {
                        return false;
                    });

                    break;
                }
                case 'BUTTON':
                case 'INPUT':
                    this.renderer.setAttribute(DOMElement, 'disabled', 'disabled');
                    break;
                default:
                    break;
            }
        }
    }

    /**
     * Directive destroy
     */
    public ngOnDestroy(): void {
        if (this.unlisten !== undefined) {
            this.unlisten();
        }
    }
}
